/** Comparaison robuste nom d'equipe / departement (casse + accents + espaces). */
export function normalizeOrgLabel(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/** True si le nom d'equipe apporte une info distincte du libelle d'echelon (badge). */
export function shouldShowOrgTeamName(
  teamName: string | null | undefined,
  levelLabel: string,
): boolean {
  if (!teamName?.trim()) return false;
  return !orgLabelsEquivalent(teamName, levelLabel);
}

/** True si les deux libelles sont equivalentes apres normalisation. */
export function orgLabelsEquivalent(a: string, b: string): boolean {
  return normalizeOrgLabel(a) === normalizeOrgLabel(b);
}
